"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.http = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const router_1 = tslib_1.__importDefault(require("@/router"));
const work_1 = require("@/store/modules/work");
const project_1 = require("@/service/project");
const user_1 = require("@/service/user");
const one_message_1 = require("@/utils/one_message");
let queue = [];
let isRefreshing = false;
let nearExpirationTime = 5000;
let http = axios_1.default.create({
    baseURL: '/',
    timeout: 30000
});
exports.http = http;
http.interceptors.request.use((config) => {
    if (!(config.headers['Content-Type'])) {
        if (config.method !== 'get') {
            config.headers['Content-Type'] =
                'application/json;charset=UTF-8';
            for (const key in config.data) {
                if (config.data[key] === '') {
                    delete config.data[key];
                }
            }
        }
    }
    let token = user_1.userToken.token.value;
    if (token && config.needAuth) {
        config.headers.Authorization = token;
        let lastRefreshTime = Number(user_1.userToken.lastRefresh.value);
        let expireTime = Number(user_1.userToken.expire.value);
        if (lastRefreshTime + expireTime - Date.now() <= nearExpirationTime) {
            let refreshExpireTime = Number(user_1.userToken.refreshExpire.value);
            let loginTime = Number(user_1.userToken.loginTime.value);
            if (loginTime + refreshExpireTime - Date.now() <= nearExpirationTime) {
                (0, one_message_1.oneMessage)("登录状态已失效，请重新登录");
                (0, user_1.logout)();
                return Promise.reject(new axios_1.default.Cancel("登录状态已失效，请重新登录"));
            }
            else {
                if (!isRefreshing) {
                    isRefreshing = true;
                    (0, user_1.refreshToken)()
                        .then((token) => {
                        queue.forEach((cb) => cb(token));
                        queue = [];
                        isRefreshing = false;
                    })
                        .catch(() => {
                        (0, user_1.clearUserToken)();
                    });
                }
                return new Promise((resolve) => {
                    queue.push((token) => {
                        config.headers.Authorization = token;
                        resolve(config);
                    });
                    console.log(queue);
                });
            }
        }
    }
    console.log('url', config.url);
    return config;
}, (error) => {
    console.error('send error', error);
    return Promise.reject(error);
});
http.interceptors.response.use((response) => {
    const dataAxios = response.data;
    return dataAxios;
}, (error) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    console.log('error', error);
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        project_1.ProjectService.current().closeAutoSave();
        const store = (0, work_1.useWork)();
        store.resetProject();
        project_1.ProjectService.current().clearCache();
        (0, user_1.clearUserToken)();
        yield router_1.default.push('/');
        return Promise.reject({
            code: error.response.status,
            message: '用户信息过期，请重新登录',
            status: error.response.statusText
        });
    }
    else if (error.message.toLowerCase() == "network error") {
        return Promise.reject({
            code: 400,
            message: '网络错误',
            status: 'error'
        });
    }
    return Promise.reject({
        code: (_b = error.response) === null || _b === void 0 ? void 0 : _b.status,
        message: error.message,
        status: (_c = error.response) === null || _c === void 0 ? void 0 : _c.statusText
    });
}));
